import type { PricingConfigurationPreviewSummary } from '@/shared/api';
import { cn } from '@/shared/lib/cn';

/** Fünf Zahlen des Servers; blockierte Tage rot, Tage mit Warnung bernstein (Board). */
export function PricingPreviewSummary({
  summary,
}: {
  summary: PricingConfigurationPreviewSummary;
}) {
  const facts = [
    ['Geprüfte Tage', summary.daysEvaluated, null],
    ['Preisänderungen', summary.rateChanges, null],
    ['Mindestaufenthalt geändert', summary.minimumStayChanges, null],
    ['Blockierte Tage', summary.blockedDays, 'text-sealwax'],
    ['Tage mit Warnung', summary.warningDays, 'text-amber-ink'],
  ] as const;
  return (
    <dl className="@2xl:grid-cols-5 grid grid-cols-2 gap-2">
      {facts.map(([label, value, tone]) => (
        <div key={label} className="bg-paper flex min-w-0 flex-col gap-0.5 rounded-lg p-3">
          <dt className="text-ink-soft text-[11px]">{label}</dt>
          <dd className={cn('font-serif text-2xl font-bold tabular-nums', value > 0 && tone)}>
            {value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
